import {NetworkProbeResult} from "@/lib/types/network.ts";

// A probe's human-readable location: the non-empty parts of its origin joined
// as "Country / State / City". Shared by the probe list, the result list and
// the probe detail header so the label reads identically everywhere.
export const originLabel = (o: NetworkProbeResult["origin"]): string =>
  [o.country, o.state, o.city].filter(Boolean).join(" / ");

// Response time rendered as seconds to millisecond precision (e.g. "1.190s"),
// or an em dash when the probe recorded no timing.
export const formatSeconds = (ms: number | null): string => (ms === null ? "—" : `${(ms / 1000).toFixed(3)}s`);
